import React from "react";
import ProductCard from "./ProductCard";

export default function ProductGrid({ products, emptyMessage, }) {


    // console.log("ProductGrid");
    // console.log(products);

    if (!products.length) {
        return (
            <div className="rounded-2xl border border-dashed border-slate-300 bg-slate-50 px-6 py-16 text-center">
                <p className="text-lg text-slate-500">{emptyMessage}</p>
            </div>
        );
    }

    return (
        <div className="grid grid-cols-1 gap-4 xs:grid-cols-2 sm:gap-5 md:grid-cols-3 lg:grid-cols-4 xl:gap-6">
            {products.map((product) => (
                <ProductCard key={product.id} product={product} />
            ))}
        </div>
    );
}
